import { GOOGLE_ANALYTICS_IDS } from '@/shared/constants';
import type { GaEvent } from '@/shared/types';

export function sendGaEvent(regionCode: string, event: GaEvent): void {
    if (typeof window === 'undefined' || !GOOGLE_ANALYTICS_IDS[regionCode.toUpperCase()]) {
        return;
    }

    try {
        window.gtag?.('event', event);
    } catch {
        // noop
    }
}
